import { cn } from 'lib/utils';
import { Check } from 'lucide-react';

interface CheckmarkProps {
  isSelected: boolean;
  className?: string;
}

export default function Checkmark({ isSelected, className }: CheckmarkProps) {
  return (
    <div
      className={cn(
        'size-[18px] rounded-full grid place-content-center border-[2px] border-gray-300 shrink-0',
        isSelected && 'bg-primary border-primary',
        className
      )}
    >
      {isSelected ? <Check className='text-white size-[14px]' /> : null}
    </div>
  );
}
